/**
 * The terms checks that have passed in this page load, so a gate mounting fresh (an account page, or
 * the protected layout after a visit to the terms page) does not ask the same person again.
 *
 * A key is `{Auth0 sub}|customer`: one person, on a page customers may open. Only a real pass is
 * written (`ProtectedGate`), never a terms-owed answer or a failed call. Held in memory only, never
 * in storage, so a page reload empties it; signing out empties it too (`App.tsx` `handleLogout`).
 */
const passes = new Set<string>();

export const hasLegalPass = (key: string): boolean => passes.has(key);

export const rememberLegalPass = (key: string): void => {
  passes.add(key);
};

export const forgetLegalPasses = (): void => {
  passes.clear();
};
